import { render, staticRenderFns } from "./Offices.vue?vue&type=template&id=81e7253e&"
import script from "./Offices.vue?vue&type=script&lang=js&"
export * from "./Offices.vue?vue&type=script&lang=js&"
import style0 from "./Offices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports